import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '../../common/react/CommonStyles';
import { cssClass } from '../../style';

const cssPrefix = 'AllUserIdentitiesSubspace';

export namespace AllUserIdentitiesSubspaceStyles {

  export const MastheadArea = cssClass(cssPrefix, 'masthead-area', {
    paddingTop: TabStyles.Spacing.LargeSpace,
    paddingRight: TabStyles.Spacing.ExtraLargeSpace,
    paddingLeft: TabStyles.Spacing.ExtraLargeSpace,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'baseline',
  });

  export const SpaceHeaderContent = cssClass(cssPrefix, 'space-header-content',  {
    marginTop: TabStyles.Spacing.MediumSpace,
    marginBottom: TabStyles.Spacing.MediumSpace,
    width: '100%',
  });

  export const SpaceHeaderText = cssClass(cssPrefix, 'space-header-text', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    marginRight: TabStyles.Spacing.ExtraLargeSpace
  });

  export const SpaceSubHeaderText = cssClass(cssPrefix, 'space-subheader-text', {
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XLarge,
    marginRight: TabStyles.Spacing.LargeSpace
  });

  export const FailureTypeButtonGroup = cssClass(cssPrefix, 'failure-type-button-group', {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '4px',
    $nest: {
      '&>*': {
        paddingRight: TabStyles.Spacing.MediumSpace,
        paddingLeft: TabStyles.Spacing.MediumSpace,
      },
      '&>*:last-child': {
        paddingRight: 0,
        marginLeft: 'auto',
      },
      '&>*:first-child': {
        paddingLeft: 0,
      }
    }
  });

  export const FailureTypeItem = cssClass(cssPrefix, 'failure-type-item', {
    color: CommonStyles.Colors.Grey102,
    display: 'flex',
    flexDirection: 'column',
  });

  export const FailureTypeItemLabel: React.CSSProperties = {
    paddingTop: '4px',
    color: CommonStyles.Colors.DiscreteBlue,
    fontWeight: 'normal',
    textAlign: 'center',
    fontSize: TabStyles.Typography.Sizing.XLarge,
  };

  export const FailureTypeItemCount: React.CSSProperties = {
    paddingTop: '10px',
    fontWeight: 'normal',
    fontSize: TabStyles.Typography.Sizing.XXLarge,
    textAlign: 'center',
  };
}
